import { useEffect, useState } from "react";
import api, { fmtDT } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import VoiceInput from "@/components/VoiceInput";

export default function Emergency() {
  const [rows, setRows] = useState([]);
  const [charges, setCharges] = useState([]);
  const [patients, setPatients] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ patient_id: "", doctor_id: "", chief_complaint: "", diagnosis: "", treatment: "", charges: [] });

  const load = () => api.get("/emergency").then((r) => setRows(r.data));
  useEffect(() => {
    load();
    api.get("/emergency-charges").then((r) => setCharges(r.data));
    api.get("/patients").then((r) => setPatients(r.data));
    api.get("/doctors").then((r) => setDoctors(r.data));
  }, []);

  const toggleCharge = (c) => {
    const exists = form.charges.find((x) => x.name === c.name);
    if (exists) setForm({ ...form, charges: form.charges.filter((x) => x.name !== c.name) });
    else setForm({ ...form, charges: [...form.charges, { name: c.name, amount: c.amount }] });
  };
  const setChargeAmt = (name, amt) => setForm({ ...form, charges: form.charges.map((c) => c.name === name ? { ...c, amount: parseFloat(amt) || 0 } : c) });

  const submit = async () => {
    try { await api.post("/emergency", form); toast.success("Emergency registered"); setOpen(false); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between"><h1 className="font-display text-2xl font-semibold">Emergency</h1><Button data-testid="new-emergency-btn" onClick={() => setOpen(true)} className="bg-red-700 hover:bg-red-800 rounded-sm">+ Register Emergency</Button></div>
      <div className="bg-white border p-4">
        <table className="w-full text-sm">
          <thead><tr className="text-left bg-slate-50"><th className="label-tiny p-2">Emergency No</th><th className="label-tiny">Patient</th><th className="label-tiny">Doctor</th><th className="label-tiny">Diagnosis</th><th className="label-tiny">Arrival</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b"><td className="font-mono p-2">{r.emergency_no}</td><td>{r.patient_name}</td><td>{r.doctor_name}</td><td>{r.diagnosis}</td><td>{fmtDT(r.arrival)}</td></tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl">
          <DialogHeader><DialogTitle>Emergency Registration</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-2">
              <select className="border h-9" value={form.patient_id} onChange={(e) => setForm({ ...form, patient_id: e.target.value })}>
                <option value="">-- Patient --</option>
                {patients.map((p) => <option key={p.id} value={p.id}>{p.name} ({p.uhid})</option>)}
              </select>
              <select className="border h-9" value={form.doctor_id} onChange={(e) => setForm({ ...form, doctor_id: e.target.value })}>
                <option value="">-- Doctor --</option>
                {doctors.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
            <VoiceInput as="input" testid="er-cc" placeholder="Chief Complaint" value={form.chief_complaint} onChange={(v) => setForm({ ...form, chief_complaint: v })} />
            <VoiceInput as="input" testid="er-dx" placeholder="Diagnosis" value={form.diagnosis} onChange={(v) => setForm({ ...form, diagnosis: v })} />
            <VoiceInput as="input" testid="er-tx" placeholder="Treatment" value={form.treatment} onChange={(v) => setForm({ ...form, treatment: v })} />
            <div>
              <div className="label-tiny mb-2">Charges</div>
              <div className="grid grid-cols-2 gap-2">
                {charges.map((c) => {
                  const sel = form.charges.find((x) => x.name === c.name);
                  return (
                    <div key={c.id} className={`flex items-center gap-2 border p-2 ${sel ? "border-blue-500 bg-blue-50" : "border-slate-200"}`}>
                      <input type="checkbox" checked={!!sel} onChange={() => toggleCharge(c)} />
                      <span className="flex-1 text-sm">{c.name}</span>
                      <input type="number" className="w-20 border border-slate-300 h-8 text-right font-mono text-xs px-1" value={sel ? sel.amount : c.amount} onChange={(e) => setChargeAmt(c.name, e.target.value)} disabled={!sel} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button><Button onClick={submit} className="bg-red-700 hover:bg-red-800">Register</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
